module.exports = {
  email: 'yashrajsrivastava2312@gmail.com',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/yashraj2312',
    },
    
    {
      name: 'Twitter',
      url: 'https://twitter.com/mister_bourbon',
    },
    // {
    //   name: 'Linkedin',
    //   url: 'https://www.linkedin.com/in/yashraj2312',
    // },
    
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Case studies and reports',
      url: '/#projects',
    },
    {
      name: 'Work experience',
      url: '/#jobs',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
    {
      name: 'My journey & work ethic',
      url: '/archive',
    },
    {
      name: 'Creative Cover Letter',
      url: 'https://drive.google.com/file/d/1AGWCowRTUQQARlGYC7tAEYQkhD_7oYS3/view?usp=drive_link',
    }
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
